import httpUtil from "../assets/script/utils/http";
// import config from '../assets/script/config'

const state = {
  image: {
    list: [],
    rowCount: 0
  },
  collect: {
    list: [],
    rowCount: 0
  }
};

const mutations = {
  setImage(state, payload) {
    state.image.list = payload.list;
    state.image.rowCount = payload.rowCount;
  },
  setCollect(state, payload) {
    state.collect.list = payload.list;
    state.collect.rowCount = payload.rowCount;
  }
};

//
const actions = {
  //更多标签
  ATag(ctx, params) {
    return httpUtil.post("/tags/tag", params);
  },
  AStyle(ctx, params) {
    return httpUtil.post("/style/data", params);
  },
  ARecommend(ctx, params) {
    return httpUtil.post("/style/recommend", params);
  },
  ANear(ctx, params) {
    return httpUtil.post("/style/near", params);
  },
  //收藏样式
  AFavoriteStyle(ctx, params) {
    return httpUtil.post("/style/favoritestyle", params);
  },
  //取消收藏样式
  AFavoriteDel(ctx, params) {
    return httpUtil.post("/style/favoritedel", params);
  },
  //使用记录
  AUse(ctx, params) {
    return httpUtil.post("/style/use", params);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
